export default {

  methods: {

    set_LocalValues(){

      this.subSystem = JSON.parse(JSON.stringify(this.DataItems))
      this.system = JSON.parse(JSON.stringify(this.Queries.SQL1))



      let json = JSON.parse(JSON.stringify(this.JQueries))

      this.revision = json.revision
      this.group    = json.group
      this.status   = json.status
      this.columns  = json.columns
      this.mcc      = json.mcc
      this.links    = json.links

      this.sundries = json.sundries
      this.keys     = json.keys
      this.filters  = json.filters
      
      this.gmx_tableCoordinates('x', this.columns, 0)

      
    },



    set_Gradients() {

    },
  },
}